import React, { memo, ReactNode } from 'react';
import styled from 'styled-components';
import { H1 } from 'global-styles';
import { useRouter } from 'next/router';
import { AboutLearnMoreArrow } from 'assets/icons';
import { scrollTo } from 'seamless-scroll-polyfill';
import Image from 'next/image';
import { generateCssStyle, mediaQueryStyle } from 'styles/breakPoints';
import {
  ImgBackgroundWrapper,
  MainVisualInnerContainer,
  MainVisualOuterContainer,
} from 'components/Common/CommonWrappers';
import { MainButton } from 'global-styles/MainButton';

type Props = {
  backgroundImageSrc: string;
  innerContainerTitle: { en: string; ko: string };
  descriptionTextComponent: {
    en: ReactNode;
    ko: ReactNode;
  };
};

export const CommonMainVisual = memo(
  ({
    backgroundImageSrc,
    innerContainerTitle,
    descriptionTextComponent,
  }: Props) => {
    const { locale } = useRouter();
    const handleClickLearnMore = () => {
      const $heightContainer = document.querySelector(
        '.main-section-container'
      );
      if ($heightContainer) {
        scrollTo(window, {
          top: $heightContainer.getBoundingClientRect().height,
          behavior: 'smooth',
        });
      }
    };

    return (
      <CommonMainVisualContainer className="main-section-container">
        <ImgBackgroundWrapper>
          <Image
            // src={backgroundImg.src}
            src={backgroundImageSrc}
            layout="fill"
            alt="bluedot blog"
            className="target-img"
            objectFit="cover"
            sizes="(min-width: 906px) 90vw,
                 (min-width: 600px) 88vw,
                 (max-width: 599px) 80vw"
            loading="eager"
            quality={30}
            priority
          />
        </ImgBackgroundWrapper>

        <MainVisualInnerContainer>
          <H1 className="main-typo" as="h2">
            {locale === 'en' ? innerContainerTitle.en : innerContainerTitle.ko}
          </H1>

          <div className="desc-text-wrapper">
            <div className="anim-wrapper">
              {locale === 'en' ? (
                <>{descriptionTextComponent.en}</>
              ) : (
                <>{descriptionTextComponent.ko}</>
              )}
            </div>
          </div>

          <MainButton
            buttonType="default-w"
            icon={<AboutLearnMoreArrow />}
            iconPosition="right"
            injectCssStyles={[
              generateCssStyle({
                'margin-top': '32px',
                animation: `txtAnimation 0.8s 1.5s cubic-bezier(0.4, 0, 0.2, 1) backwards`,
              }),
              mediaQueryStyle.M`margin-top:56px;`,
            ]}
            injectInlineStyles={{ width: '328px', height: '56px' }}
            text={locale === 'en' ? 'Learn more' : '더 알아보기'}
            onClick={handleClickLearnMore}
          />
        </MainVisualInnerContainer>
      </CommonMainVisualContainer>
    );
  }
);

CommonMainVisual.displayName = 'BlogMainVisual';

const CommonMainVisualContainer = styled(MainVisualOuterContainer)``;

// const KO = () => (
//   <div className="ko-wrapper">
//     <SubtitleM>
//       <div>
//         미디어 트렌드 및 동영상 기술을 제공하는 블루닷의 노하우를 전합니다.
//       </div>
//     </SubtitleM>
//   </div>
// );

// const EN = () => (
//   <>
//     <div className="en-wrapper-pc">
//       <SubtitleM>
//         <span>BLUEDOT is a startup that utilizes Semiconductor Design and</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Deep Learning to provide Fast and Intelligent Video</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>
//           Processing and Compression technologies through Cloud Data Center.
//         </span>
//       </SubtitleM>
//     </div>
//     <div className="en-wrapper-mo">
//       <SubtitleM>
//         <span>BLUEDOT is a startup that utilizes</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Semiconductor Design and</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Deep Learning to provide Fast and</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Intelligent Video Processing and</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Compression technologies through</span>
//       </SubtitleM>
//       <SubtitleM>
//         <span>Cloud Data Center.</span>
//       </SubtitleM>
//     </div>
//   </>
// );
